export const UMO_TYPE_IMAGE = 'PHOTO';
export const UMO_TYPE_VIDEO = 'VIDEO';
export const UMO_TYPE_DOCUMENT = 'DOCUMENT';
export const UMO_TYPE_RELATIONAL = 'RELATIONAL';
export const UMO_TYPE_AUDIO = 'AUDIO';



// WEBPACK FOOTER //
// ./src/js/constants/umo.js